// const path = '/loadTypes'
import { mixinActions, mixinMutations, mixinState } from "../../mixins/vuexCRUD"

const getters = {
  loadTypes: (state) => state.items,
}

const state = {
  ...mixinState(),
  path: '/loadTypes'
}

const mutations = mixinMutations()

const actions = mixinActions()


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}